import axiosInstance from './axiosInstance';
import { decodeJwtToken } from '../utils/jwtUtils';

export const getAllVehicles = async () => {
  try {
    const response = await axiosInstance.get('/Corrohealth/vehicles/getAllVehicles');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getVehiclesByLocationFromToken = async () => {
  try {
    const response = await axiosInstance.get('/Corrohealth/vehicles/getVehiclesByLocation');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAvailableVehiclesByLocationAndTiming = async (timing) => {
  try {
    const rawToken = localStorage.getItem('authToken') || sessionStorage.getItem('authToken') || localStorage.getItem('token') || sessionStorage.getItem('token');
    const token = rawToken ? rawToken.trim().replace(/^"|"$/g, '').replace(/^Bearer\s+/i, '') : null;
    const decoded = token ? decodeJwtToken(token) : null;
    const location = decoded?.location || decoded?.Location;

    const toAmPm = (time24) => {
      if (!time24) return undefined;
      const [hhStr, mmStr] = String(time24).split(':');
      const hour24 = parseInt(hhStr, 10);
      const minute = parseInt(mmStr, 10);
      if (Number.isNaN(hour24) || Number.isNaN(minute)) return time24;
      const meridiem = hour24 >= 12 ? 'PM' : 'AM';
      let hour12 = hour24 % 12;
      if (hour12 === 0) hour12 = 12;
      const minutesPadded = String(minute).padStart(2, '0');
      return `${hour12}:${minutesPadded} ${meridiem}`;
    };

    const params = { };
    if (location) params.location = location;
    if (timing) params.timing = toAmPm(timing);

    const response = await axiosInstance.get('/Corrohealth/vehicles/vehiclesBylocationAndTiming', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default {
  getAllVehicles,
  getVehiclesByLocationFromToken,
  getAvailableVehiclesByLocationAndTiming,
};


